import React from 'react'
import Modal from 'modals/dialog'
import { ModalBody } from './s'

const Video = ({ show, dismiss, salt, children }) => (
    <Modal
        show={show}
        dismiss={dismiss}
        className="fullscreen plain"
        salt={salt}>
        {!!show && (
            <ModalBody>
                {children}
            </ModalBody>
        )}
    </Modal>
)

export default Video
